module.exports = __webpack_public_path__ + "img/VCA.bd1bb3be.png";